module.exports = __webpack_public_path__ + "static/media/standard.6638e776.svg";